// Mock data for FinanzierungsPilot website

export const heroData = {
  title: "Finden Sie die beste Finanzierung",
  subtitle: "schnell, transparent und persönlich",
  description: "Wir vergleichen über 500 Partnerbanken und finden für Sie die optimale Finanzierungslösung – ob Immobilie, Kredit oder Umschuldung.",
  ctaText: "Jetzt unverbindlich Anfrage stellen",
  backgroundImage: "https://images.pexels.com/photos/8962677/pexels-photo-8962677.jpeg?auto=compress&cs=tinysrgb&w=1200"
};

export const advantages = [
  {
    id: 1,
    icon: "Building2",
    title: "500+ Partnerbanken",
    description: "Zugang zu über 500 renommierten Kreditinstituten für den besten Zinsvergleich"
  },
  {
    id: 2,
    icon: "Clock",
    title: "Schnelle Bearbeitung",
    description: "Ihre Anfrage wird innerhalb von 24 Stunden von unseren Experten bearbeitet"
  },
  {
    id: 3,
    icon: "UserCheck",
    title: "Persönliche Beratung",
    description: "Individuelle Betreuung durch zertifizierte Finanzberater"
  },
  {
    id: 4,
    icon: "Shield",
    title: "Datenschutz garantiert",
    description: "Ihre Daten sind bei uns sicher und werden vertraulich behandelt"
  },
  {
    id: 5,
    icon: "Percent",
    title: "Beste Konditionen",
    description: "Wir verhandeln für Sie die günstigsten Zinssätze am Markt"
  },
  {
    id: 6,
    icon: "Award",
    title: "Unabhängige Beratung",
    description: "Keine versteckten Provisionen – 100% kundenorientiert"
  }
];

export const howItWorks = [
  {
    step: 1,
    title: "Anfrage stellen",
    description: "Füllen Sie unser einfaches Online-Formular aus und teilen Sie uns Ihre Wünsche mit."
  },
  {
    step: 2,
    title: "Angebote vergleichen",
    description: "Wir vergleichen für Sie die besten Konditionen aus über 500 Partnerbanken."
  },
  {
    step: 3,
    title: "Finanzierung abschließen",
    description: "Wählen Sie das beste Angebot und schließen Sie Ihre Finanzierung ab."
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Michael Schneider",
    location: "München",
    rating: 5,
    text: "Dank FinanzierungsPilot haben wir unsere Traumimmobilie finanzieren können. Der Service war erstklassig und die Beratung sehr kompetent.",
    avatar: "MS"
  },
  {
    id: 2,
    name: "Sandra Weber",
    location: "Hamburg",
    rating: 5,
    text: "Schnell, unkompliziert und transparent. Ich konnte durch den Vergleich über 15.000€ bei meiner Umschuldung sparen!",
    avatar: "SW"
  },
  {
    id: 3,
    name: "Thomas Müller",
    location: "Berlin",
    rating: 5,
    text: "Die persönliche Beratung war hervorragend. Mein Berater hat sich wirklich Zeit genommen und alle meine Fragen beantwortet.",
    avatar: "TM"
  },
  {
    id: 4,
    name: "Anna Fischer",
    location: "Frankfurt",
    rating: 4,
    text: "Sehr professioneller Service. Die Online-Plattform ist einfach zu bedienen und die Angebote kamen schnell.",
    avatar: "AF"
  }
];

export const partnerBanks = [
  { id: 1, name: "Deutsche Kredit AG", abbr: "DK", colors: ["#003366", "#0066CC"] },
  { id: 2, name: "Norddeutsche Finanz", abbr: "NF", colors: ["#FF6600", "#FFB800"] },
  { id: 3, name: "Süd-West Bank", abbr: "SW", colors: ["#CC0000", "#FF3333"] },
  { id: 4, name: "Erste Hypothek", abbr: "EH", colors: ["#0099CC", "#00CCFF"] },
  { id: 5, name: "Berliner Darlehen", abbr: "BD", colors: ["#006633", "#009933"] },
  { id: 6, name: "Münchner Kredit", abbr: "MK", colors: ["#660099", "#9933CC"] },
  { id: 7, name: "Hanseatische Bank", abbr: "HB", colors: ["#CC6600", "#FF9933"] },
  { id: 8, name: "Rhein-Main Finanz", abbr: "RF", colors: ["#003399", "#0066FF"] }
];

export const financingTypes = [
  {
    id: "kapitalbeschaffung",
    title: "Kapitalbeschaffung",
    icon: "Banknote",
    shortDesc: "Kapital für Ihre Vorhaben",
    description: "Flexible Kapitalbeschaffung für private und geschäftliche Zwecke – schnell, unkompliziert und zu attraktiven Konditionen.",
    features: ["Freie Verwendung", "Schnelle Auszahlung", "Flexible Laufzeiten", "Attraktive Zinsen"],
    rates: { minRate: "2,5%", maxAmount: "200.000€", term: "12-180 Monate" }
  },
  {
    id: "immobilien",
    title: "Immobilienfinanzierung",
    icon: "Home",
    shortDesc: "Baufinanzierung & Hauskauf",
    description: "Ob Neubau, Kauf oder Modernisierung – wir finden die passende Immobilienfinanzierung für Ihr Vorhaben.",
    features: ["Günstige Zinsen ab 2,8%", "Flexible Laufzeiten", "Sondertilgung möglich", "KfW-Förderung"],
    rates: { minRate: "2,8%", maxAmount: "500.000€", term: "5-30 Jahre" }
  },
  {
    id: "kredit",
    title: "Kreditvergleich",
    icon: "CreditCard",
    shortDesc: "Ratenkredite im Vergleich",
    description: "Vergleichen Sie Ratenkredite von über 100 Banken und sparen Sie bares Geld.",
    features: ["Sofortzusage möglich", "Ohne Sicherheiten", "Freie Verwendung", "Schnelle Auszahlung"],
    rates: { minRate: "2,9%", maxAmount: "100.000€", term: "12-120 Monate" }
  },
  {
    id: "umschuldung",
    title: "Umschuldung",
    icon: "RefreshCw",
    shortDesc: "Bestehende Kredite optimieren",
    description: "Senken Sie Ihre monatlichen Raten durch die Zusammenfassung bestehender Kredite.",
    features: ["Bis zu 40% Ersparnis", "Ein Kredit statt viele", "Übersichtliche Finanzen", "Niedrigere Zinsen"],
    rates: { minRate: "3,2%", maxAmount: "150.000€", term: "12-120 Monate" }
  },
  {
    id: "ratenkredit",
    title: "Ratenkredit",
    icon: "Wallet",
    shortDesc: "Für private Anschaffungen",
    description: "Der klassische Ratenkredit für Auto, Möbel, Urlaub oder andere Wünsche.",
    features: ["Feste Monatsraten", "Planbare Laufzeit", "Keine Zweckbindung", "Online abschließbar"],
    rates: { minRate: "3,5%", maxAmount: "75.000€", term: "12-84 Monate" }
  },
  {
    id: "geschaeft",
    title: "Geschäftskredit",
    icon: "Briefcase",
    shortDesc: "Für Selbstständige & Unternehmen",
    description: "Finanzierungslösungen für Ihr Unternehmen – von der Investition bis zum Betriebsmittelkredit.",
    features: ["Flexible Konditionen", "Schnelle Entscheidung", "Individuelle Beratung", "Verschiedene Sicherheiten"],
    rates: { minRate: "4,0%", maxAmount: "250.000€", term: "12-120 Monate" }
  }
];

export const teamMembers = [
  {
    id: 1,
    name: "Dr. Martin Hoffmann",
    role: "Geschäftsführer",
    image: "https://images.unsplash.com/photo-1560250097-0b93528c311a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwxfHxidXNpbmVzc21hbiUyMHBvcnRyYWl0fGVufDB8fHx8MTc2OTA2OTYzOXww&ixlib=rb-4.1.0&q=85",
    description: "20 Jahre Erfahrung in der Finanzbranche"
  },
  {
    id: 2,
    name: "Julia Bergmann",
    role: "Leiterin Kundenberatung",
    image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwyfHxidXNpbmVzcyUyMHByb2Zlc3Npb25hbHxlbnwwfHx8fDE7Njg4Nzc3ODh8MA&ixlib=rb-4.1.0&q=85",
    description: "Spezialistin für Immobilienfinanzierung"
  },
  {
    id: 3,
    name: "Stefan Richter",
    role: "Senior Finanzberater",
    image: "https://images.pexels.com/photos/2381069/pexels-photo-2381069.jpeg",
    description: "Experte für Unternehmensfinanzierung"
  }
];

export const consultationBenefits = [
  {
    id: 1,
    title: "Individuelle Analyse",
    description: "Wir analysieren Ihre finanzielle Situation und finden die optimale Lösung."
  },
  {
    id: 2,
    title: "Persönlicher Ansprechpartner",
    description: "Ein fester Berater begleitet Sie durch den gesamten Prozess."
  },
  {
    id: 3,
    title: "Transparente Beratung",
    description: "Keine versteckten Kosten – alle Konditionen werden offen kommuniziert."
  },
  {
    id: 4,
    title: "Flexibilität",
    description: "Beratung per Telefon, Video oder persönlich – ganz wie Sie möchten."
  }
];

export const faqData = [
  {
    category: "Allgemein",
    questions: [
      {
        q: "Ist die Beratung wirklich kostenlos?",
        a: "Ja, unsere Beratung ist für Sie vollkommen kostenlos und unverbindlich. Wir werden von unseren Partnerbanken vergütet."
      },
      {
        q: "Wie lange dauert die Bearbeitung meiner Anfrage?",
        a: "In der Regel erhalten Sie innerhalb von 24 Stunden eine erste Rückmeldung und passende Angebote."
      },
      {
        q: "Bin ich nach der Anfrage zu etwas verpflichtet?",
        a: "Nein, Ihre Anfrage ist völlig unverbindlich. Sie entscheiden selbst, ob Sie ein Angebot annehmen möchten."
      },
      {
        q: "Wie unabhängig ist Ihre Beratung?",
        a: "Wir sind an keine Bank gebunden und vergleichen objektiv die Angebote aller unserer über 500 Partnerbanken."
      }
    ]
  },
  {
    category: "Immobilienfinanzierung",
    questions: [
      {
        q: "Wie viel Eigenkapital benötige ich für eine Immobilienfinanzierung?",
        a: "Idealerweise sollten Sie 20-30% des Kaufpreises als Eigenkapital mitbringen. In bestimmten Fällen ist auch eine Finanzierung mit weniger Eigenkapital möglich."
      },
      {
        q: "Was ist eine Sollzinsbindung?",
        a: "Die Sollzinsbindung ist der Zeitraum, für den der Zinssatz Ihres Darlehens festgeschrieben ist. Übliche Zeiträume sind 5, 10, 15 oder 20 Jahre."
      },
      {
        q: "Kann ich Sondertilgungen leisten?",
        a: "Bei den meisten unserer Finanzierungsangebote sind jährliche Sondertilgungen von 5-10% der Darlehenssumme möglich."
      },
      {
        q: "Was sind die Nebenkosten beim Immobilienkauf?",
        a: "Rechnen Sie mit ca. 10-15% des Kaufpreises für Grunderwerbsteuer, Notar, Grundbuch und ggf. Maklerprovision."
      }
    ]
  },
  {
    category: "Kreditvergleich",
    questions: [
      {
        q: "Welche Unterlagen benötige ich für einen Kreditantrag?",
        a: "In der Regel benötigen wir: Personalausweis, Gehaltsnachweise der letzten 3 Monate, Kontoauszüge und ggf. bestehende Kreditverträge."
      },
      {
        q: "Wie schnell wird der Kredit ausgezahlt?",
        a: "Nach positiver Prüfung und Vertragsunterschrift erfolgt die Auszahlung meist innerhalb von 2-5 Werktagen."
      },
      {
        q: "Beeinflusst eine Kreditanfrage meinen SCHUFA-Score?",
        a: "Unsere Konditionsanfragen sind SCHUFA-neutral. Erst bei einem konkreten Kreditantrag wird ein Eintrag vorgenommen."
      },
      {
        q: "Kann ich einen Kredit vorzeitig zurückzahlen?",
        a: "Ja, bei Ratenkrediten haben Sie das gesetzliche Recht zur vorzeitigen Rückzahlung. Es kann eine geringe Vorfälligkeitsentschädigung anfallen."
      }
    ]
  },
  {
    category: "Umschuldung",
    questions: [
      {
        q: "Wann lohnt sich eine Umschuldung?",
        a: "Eine Umschuldung lohnt sich, wenn die Zinsen Ihrer bestehenden Kredite deutlich über dem aktuellen Marktniveau liegen oder wenn Sie mehrere Kredite zusammenfassen möchten."
      },
      {
        q: "Wie viel kann ich durch eine Umschuldung sparen?",
        a: "Je nach Ausgangssituation können Sie bis zu 40% Ihrer monatlichen Raten einsparen. Wir erstellen Ihnen gerne eine individuelle Berechnung."
      },
      {
        q: "Werden alle meine Kredite abgelöst?",
        a: "Das entscheiden Sie selbst. Sie können einzelne oder alle bestehenden Verbindlichkeiten in die Umschuldung einbeziehen."
      },
      {
        q: "Gibt es Kosten für die Umschuldung?",
        a: "Bei bestehenden Krediten kann eine Vorfälligkeitsentschädigung anfallen. Unsere Beratung zur Umschuldung ist kostenlos."
      }
    ]
  },
  {
    category: "Datenschutz & Sicherheit",
    questions: [
      {
        q: "Wie werden meine Daten geschützt?",
        a: "Ihre Daten werden SSL-verschlüsselt übertragen und gemäß DSGVO verarbeitet. Wir geben keine Daten an unbefugte Dritte weiter."
      },
      {
        q: "Wer hat Zugriff auf meine Finanzdaten?",
        a: "Nur unsere zertifizierten Berater und die von Ihnen ausgewählten Partnerbanken haben Zugriff auf Ihre Daten."
      },
      {
        q: "Kann ich meine Daten löschen lassen?",
        a: "Ja, Sie können jederzeit die Löschung Ihrer Daten beantragen. Kontaktieren Sie uns einfach per E-Mail oder Telefon."
      },
      {
        q: "Ist die Website sicher?",
        a: "Ja, unsere Website verwendet modernste Sicherheitsstandards mit SSL-Verschlüsselung und ist regelmäßig geprüft."
      }
    ]
  }
];

export const companyInfo = {
  name: "FinanzierungsPilot",
  tagline: "Ihr unabhängiger Finanzierungsvergleich",
  address: {
    street: "Münzgasse 11",
    zip: "95445",
    city: "Bayreuth",
    country: "Deutschland"
  },
  contact: {
    phone: "+49 (0) 15511 427039",
    email: "info@finanzierungspilot.net",
    hours: "Mo-Fr: 9:00 - 18:00 Uhr"
  },
  social: {
    facebook: "#",
    linkedin: "#",
    xing: "#"
  },
  legal: {
    company: "FinanzierungsPilot GmbH",
    ceo: "Dr. Martin Hoffmann",
    register: "HRB 123456, Amtsgericht München",
    vatId: "DE123456789"
  }
};

export const trustBadges = [
  { id: 1, title: "TÜV geprüft", icon: "ShieldCheck" },
  { id: 2, title: "SSL verschlüsselt", icon: "Lock" },
  { id: 3, title: "DSGVO konform", icon: "FileCheck" },
  { id: 4, title: "Ausgezeichneter Service", icon: "Star" }
];

export const consultationImages = {
  hero: "https://customer-assets.emergentagent.com/job_loan-compare-2/artifacts/ky3bmqie_%7B5C23B709-E603-40D5-A01F-FE0984806B97%7D.png",
  meeting: "https://images.pexels.com/photos/8292854/pexels-photo-8292854.jpeg",
  consultation: "https://images.pexels.com/photos/8292879/pexels-photo-8292879.jpeg",
  analysis: "https://images.pexels.com/photos/669610/pexels-photo-669610.jpeg"
};
